export default __webpack_public_path__ + "static/media/doc-icon-instruction-new.165352da.svg";